function createCartDiscountError(type, originalError) {
    return {
        type,
        originalError: originalError instanceof Error ? originalError : new Error('UNKNOWN_ERROR')
    };
}

export { createCartDiscountError };
//# sourceMappingURL=types.js.map
